import { render, staticRenderFns } from "./About.vue?vue&type=template&id=0347b8bb&"
import script from "./About.vue?vue&type=script&lang=ts&setup=true&"
export * from "./About.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./About.vue?vue&type=style&index=0&id=0347b8bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports